import { FC } from "react";
import styled from "styled-components";

const Base = styled.div<Props>`
  background: url(${(props) => props.src});
  background-size: cover;
  background-position: center;
  width: ${(props) => props.width ?? "100%"};
  height: ${(props) => props.height + "px"};
  position: relative;

  &:before {
    content: "";
    display: ${(props) => (props.overlay ? "flex" : "none")};
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, ${(props) => props.overlay}%);
  }
`;

interface Props {
  src: string;
  height: number;
  width?: number;
  overlay?: number;
  className?: string;
}

/** onErrorで画像がないときのエラーを検出できない + 画像の最適化が為されないのでNextImageでposition: absoluteを使った実装に変えたい... */
export const BackgroundImage: FC<Props> = (props: Props) => {
  return <Base {...props} />;
};
